import UiSettingsEditor from "./UiSettingsEditor";
export default {
  settingsSchema: null,
  component: UiSettingsEditor,
  hideLabel: true
};